/**
 * Premium Product Title Height Equalizer (Row-by-Row)
 * 
 * Yeh script har row ke products ke titles ki height check karta hai,
 * aur us row mein jo sabse bada title (heading) hota hai, baki sabhi
 * titles ki height bhi uske barabar set kar deta hai.
 * 
 * Yeh absolute bounding offsets of '.grid__item' use karta hai taaki:
 * - Har row ka calculation ek doosre se bilkul independent ho.
 * - Star reviews, badges ya images ki height ke farq se grouping kharab na ho.
 */
(function() {
  let equalizationTimeout = null;

  function equalizeTitleHeights() {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const headings = Array.from(gridContainer.querySelectorAll('.product-card-wrapper .card__heading'));
    if (headings.length === 0) return;

    // Step 1: Pehle sabhi headings ki height ko 'auto' reset karein taaki natural heights calculate ho sakein
    headings.forEach(heading => {
      heading.style.height = 'auto';
    });

    // Step 2: Headings ko unke respective '.grid__item' (outer row container) ki absolute top position ke mutabiq group karein
    const rows = {};
    headings.forEach(heading => {
      const gridItem = heading.closest('.grid__item');
      if (!gridItem) return;

      // Absolute vertical top offset from the document top
      const top = gridItem.getBoundingClientRect().top + window.scrollY;
      
      // 10px ki tolerance range rakhi hai sub-pixel layout aur floating difference ke liye
      let matchedTop = null;
      for (const rowTop in rows) {
        if (Math.abs(rowTop - top) < 10) {
          matchedTop = rowTop;
          break;
        }
      }

      if (matchedTop !== null) {
        rows[matchedTop].push(heading);
      } else {
        rows[top] = [heading];
      }
    });

    // Step 3: Har row ke liye maximum height find karein aur apply karein
    for (const top in rows) {
      const rowHeadings = rows[top];
      let maxHeight = 0;

      // Find max height among all headings in this specific row
      rowHeadings.forEach(heading => {
        const height = heading.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Apply max height to all headings in that row
      if (maxHeight > 0) {
        rowHeadings.forEach(heading => {
          heading.style.height = `${maxHeight}px`;
        });
      }
    }
  }

  // Debounce helper to avoid layout thrashing on fast events (like resize)
  function triggerEqualization() {
    if (equalizationTimeout) {
      cancelAnimationFrame(equalizationTimeout);
    }
    equalizationTimeout = requestAnimationFrame(() => {
      equalizeTitleHeights();
    });
  }

  // Bind events
  window.addEventListener('resize', triggerEqualization);
  window.addEventListener('load', triggerEqualization);
  document.addEventListener('DOMContentLoaded', triggerEqualization);

  // Set up MutationObserver to auto-trigger when grid updates (filters or infinite scroll append)
  function watchGridForHeight() {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const observer = new MutationObserver(() => {
      // Jab bhi grid updates honge, ye height adjust kar dega
      triggerEqualization();
    });

    observer.observe(gridContainer, {
      childList: true,
      subtree: true
    });
  }

  // Initial execution & observer binding
  triggerEqualization();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGridForHeight);
  } else {
    watchGridForHeight();
  }

  // Hot-reloading support in Shopify Theme Editor
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', triggerEqualization);
  }
})();
